// @flow
import * as R from "ramda"
import { createSelector } from "reselect"

import Price from "common/records/Price"
import type {
  Action,
  InsuranceState,
} from "booking/services/additionalServices/services/insurance/types"

const INITIAL_VALUES: InsuranceState = {
  data: {},
  ordered: {},
  validation: {},
}

export default function insuranceReducer(state: InsuranceState = INITIAL_VALUES, action: Action) {
  switch (action.type) {
    case "SET_PASSENGERS_INSURANCE":
      return {
        ...state,
        ordered: action.payload,
      }

    case "INSURANCE_LOADED":
      return { ...state, data: action.payload }

    case "UNSET_PASSENGER_INSURANCE": {
      // $FlowFixMe: error revealed by updating Flow and Ramda libdef
      const ordered: $PropertyType<typeof state, "ordered"> = R.pipe(
        R.omit([String(action.payload)]),
        R.toPairs,
        R.map(([strKey, value]) => {
          const numKey = Number(strKey)
          return numKey > action.payload ? [numKey - 1, value] : [numKey, value]
        }),
        R.fromPairs,
      )(state.ordered)
      return {
        ...state,
        ordered,
      }
    }

    default:
      return state
  }
}

// NOTE: getAdditionalServices leads to circular dependencies
// $FlowFixMe
export const getInsurance = (state: any) => state.reservation.additionalServices.insurance
// $FlowFixMe
export const getInsuranceData = createSelector(
  getInsurance,
  state => state.data,
)
// $FlowFixMe
export const getInsurancePassengers = createSelector(
  getInsurance,
  state => state.ordered,
)
// $FlowFixMe
export const insurancePriceSelector = createSelector(
  getInsuranceData,
  getInsurancePassengers,
  (data, passengers) => Price.sum(Object.values(passengers).map(x => R.prop("price", data[x]))),
)
